module.exports = __webpack_public_path__ + "img/title.b04ca87d.png";